var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThresholdBased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11296_64035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 23.5967C33.9125 23.8266 33.8032 24.5472 33.7425 24.8366C33.5794 25.5793 33.3224 26.2983 32.9783 26.9763C31.8092 29.3152 29.7556 31.0912 27.2726 31.9107C24.8494 32.7012 22.2116 32.4991 19.9371 31.3486C17.633 30.1916 15.8808 28.1691 15.064 25.7236C14.2552 23.2593 14.4602 20.5745 15.6336 18.2616C16.788 15.9748 18.8051 14.2415 21.2395 13.4443C23.6921 12.6307 26.3685 12.834 28.67 14.0088C30.9723 15.1774 32.7166 17.2122 33.5197 19.666C33.7591 20.4066 33.8162 21.1956 34.0001 21.7572V23.5967Z",
    fill: "#095228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10827L0.0152065 6.08244C0.237736 5.69998 0.319836 5.32591 0.67399 4.93169C1.83755 3.63647 3.93786 2.78388 5.60419 2.34464C10.3369 1.14554 15.9197 1.31749 20.2957 3.6366C21.1028 4.06432 22.3972 5.09196 22.5864 5.99691C23.1268 8.58177 18.6685 10.2429 16.7527 10.6966C12.0731 11.8049 6.49294 11.5935 2.2172 9.23365C1.5902 8.87712 0.770362 8.2359 0.378403 7.61683C0.219277 7.36551 0.121547 7.028 0 6.83798V6.10827Z",
    fill: "#095228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6797C0.398524 11.9068 0.793814 12.1637 1.20234 12.3725C5.01095 14.3193 9.46853 14.7796 13.6859 14.4662C13.8889 14.4511 14.1026 14.4388 14.3022 14.4071C13.3077 15.6832 12.942 16.3427 12.2869 17.7922C8.77824 17.9607 3.81125 17.256 1.03083 14.8483C0.687351 14.5508 0.405892 14.178 0.207574 13.7711C0.164048 13.6817 0.030628 13.3622 0 13.3178V11.6797Z",
    fill: "#095228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.6211C2.70024 26.2959 5.42001 27.0566 8.58394 27.3798C9.4096 27.4572 10.2379 27.5041 11.067 27.5201C12.6611 27.55 12.075 27.2815 12.8026 28.6443C13.0267 29.0709 13.2745 29.4847 13.5446 29.8837C13.6921 30.1041 13.9171 30.4039 14.0463 30.6202C13.1106 30.7007 11.9996 30.8121 11.0261 30.7822C7.78623 30.6825 3.91398 30.0601 1.28304 28.0124C0.931829 27.739 0.432169 27.2184 0.251702 26.8134C0.217918 26.7376 0.0151478 26.2887 0 26.2671V24.6211Z",
    fill: "#095228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.1523C0.807849 18.6366 1.42858 18.9947 2.29586 19.3646C5.00783 20.5213 8.49157 21.0904 11.4335 21.0444C11.3024 22.1245 11.3026 23.2166 11.4343 24.2967C10.9485 24.2899 10.3717 24.2922 9.87617 24.2543C6.84037 24.022 3.11521 23.2909 0.827186 21.1265C0.570758 20.8839 0.319582 20.4815 0.16773 20.1674C0.124051 20.0771 0.0442332 19.8551 0 19.794V18.1523Z",
    fill: "#095228"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11296_64035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThresholdBased);
export default __webpack_public_path__ + "static/media/threshold-based.30763f147776c29d88861bffbad5332f.svg";
export { ForwardRef as ReactComponent };